// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"384":"highlight.js","774":"tinymce"}[chunkId] + "." + chunkId + ".css";
};